import axios from './axiosConfig'
import { getEnv } from '@utils/env'
import type { AssistantSchedule } from '@dataTypes/aiAssist.type'
import type { AiCompletionResponse, AiFeatureKey } from './ai.api'

const AI_BUSINESS_API = getEnv('REACT_APP_BUSINESS_LAYER_AI')

export type AssistantAction =
  | 'chat'
  | 'web_search'
  | Exclude<AiFeatureKey, 'custom'>

export type AssistantTurn = { role: 'user' | 'assistant'; content: string }

export type AssistantCitation = {
  start_index: number
  end_index: number
  url: string
  title: string
}

export type {
  AssistantSchedule,
  AssistantScheduleItem,
} from '@dataTypes/aiAssist.type'

type AssistantResponse = AiCompletionResponse['data'] & {
  citations?: AssistantCitation[]
  schedule?: AssistantSchedule
}

export type AiAssistantResponse = {
  statusCode: number
  message: string
  data: AssistantResponse
}

export const postAssistantMessage = async (
  payload: {
    clinic_id: string
    request_id: string
    action: AssistantAction
    message: string
    history: AssistantTurn[]
  },
  signal: AbortSignal,
): Promise<AssistantResponse> => {
  const response = await axios.post<AiAssistantResponse>(
    `${AI_BUSINESS_API}/api/v1/ai/assistant/messages`,
    payload,
    { signal, timeout: 120000 },
  )
  if (response.data.statusCode !== 200 || !response.data.data?.content) {
    throw new Error(
      'AI Assistant returned an empty response. Please try again.',
    )
  }
  return response.data.data
}
